import { useAuth } from '@/lib/auth/auth';
import type { VenueDetail } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const venueDetailKeys = {
  all: ['venue-detail'] as const,
  detail: (id: string) => [...venueDetailKeys.all, id] as const,
};

export function useVenueDetail(id?: string | null) {
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: id ? venueDetailKeys.detail(id) : venueDetailKeys.all,
    enabled: Boolean(id),
    queryFn: () => {
      if (!id) {
        throw new Error('Missing venue id');
      }
      return request<VenueDetail>(`/venues/${id}`);
    },
    refetchOnMount: 'always',
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
}
